import Nullstack from 'nullstack';
export default function IconTrekking({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-trekking",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 21l2 -4"
  }), "   ", Nullstack.element("path", {
    d: "M13 21v-4l-3 -3l1 -6l3 4l3 2"
  }), "   ", Nullstack.element("path", {
    d: "M10 14l-1.827 -1.218a2 2 0 0 1 -.831 -2.15l.28 -1.117a2 2 0 0 1 1.939 -1.515h1.439l4 1l3 -2"
  }), "   ", Nullstack.element("path", {
    d: "M17 12v9"
  }), "   ", Nullstack.element("path", {
    d: "M16 20h2"
  }), " ");
}